import { StandardEvents } from '@shopify/events';
import { DrawerOpenEvent } from '@theme/theme-drawer';
const states = new WeakMap();
let pending = 0;
const selector = 'cart-consent';
const inputFor = scope => scope.querySelector('input[type="checkbox"]');
function stateFor(scope) {
 const signature = scope.dataset.consentCart, input = inputFor(scope);
 let state = states.get(scope);
 if (!state || state.signature !== signature || state.input !== input) {
  state = {signature,input,accepted:false}; states.set(scope,state);
  if(input) input.checked=false;
 }
 return state;
}
function allowed(scope) {
 const state=stateFor(scope);
 return !pending && state.accepted && Boolean(state.input?.checked);
}
function sync() {
 document.querySelectorAll(selector).forEach(scope=>{
  const blocked=!allowed(scope), ctas=scope.closest('.cart__ctas');
  if(!ctas) return;
  if(ctas.hasAttribute('data-consent-blocked')!==blocked) ctas.toggleAttribute('data-consent-blocked',blocked);
  ctas.querySelectorAll('.cart__checkout-button').forEach(button=>{
   button.disabled=scope.dataset.cartEmpty==='true';
   if(button.getAttribute('aria-disabled')!==String(blocked)) button.setAttribute('aria-disabled',String(blocked));
  });
 });
}
function reset() {
 document.querySelectorAll(selector).forEach(scope=>{
  const state=stateFor(scope); state.accepted=false;
  if(state.input) state.input.checked=false;
 }); sync();
}
function refuse(event,scope) {
 event.preventDefault(); event.stopImmediatePropagation();
 window.alert(pending ? 'Your cart is updating. Please wait, then accept the Terms of Service and Return Policy.' : 'Please read and accept the Terms of Service and Return Policy before continuing.');
 inputFor(scope)?.focus();
}
document.addEventListener('change',event=>{
 const input=event.target;
 if(!(input instanceof HTMLInputElement)) return;
 const scope=input.closest(selector);
 if(!scope || input!==inputFor(scope)) return;
 const checked=input.checked, state=stateFor(scope);
 state.accepted=!pending && checked; input.checked=state.accepted; sync();
},true);
document.addEventListener('click',event=>{
 if(!(event.target instanceof Element)) return;
 const button=event.target.closest('.cart__checkout-button, [name="checkout"]');
 if(!button) return;
 const scope=button.closest('.cart__ctas')?.querySelector(selector);
 if(scope && !allowed(scope)) refuse(event,scope);
},true);
document.addEventListener('submit',event=>{
 if(!(event.target instanceof HTMLFormElement)) return;
 const form=event.target, submitter=event.submitter;
 const button=submitter?.matches('.cart__checkout-button, [name="checkout"]') ? submitter :
 Array.from(document.querySelectorAll('.cart__checkout-button')).find(candidate=>candidate.form===form && candidate.getClientRects().length);
 if(!button || button.form!==form) return;
 const scope=button.closest('.cart__ctas')?.querySelector(selector);
 if(scope && !allowed(scope)) refuse(event,scope);
},true);
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{
 pending++; reset();
 const settled=()=>requestAnimationFrame(()=>{pending=Math.max(0,pending-1);reset();});
 if(event.promise?.then) event.promise.then(settled,settled); else settled();
},true);
document.addEventListener(DrawerOpenEvent.eventName,event=>{
 if(event.target instanceof Element && event.target.querySelector(selector)) reset();
},true);
window.addEventListener('pageshow',reset);
// Observe cart replacement and line fingerprints, not our own lock attributes.
new MutationObserver(sync).observe(document.documentElement,{
 childList:true,subtree:true,attributes:true,
 attributeFilter:['data-consent-cart','data-cart-empty']
});
sync();
